module.exports = __webpack_public_path__ + "img/yinlian.43da40f4.png";